import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';

class PartTMC extends Component {
  renderNumericValue(width, value = 0) {
    return <Grid.Column width={width}>{value}</Grid.Column>;
  }

  renderLabel(width, label, paddingLeft) {
    const classes = paddingLeft ? 'padding-left' : '';
    return (
      <Grid.Column width={width} className={classes}>
        <span className='bolder'>{label}</span>
      </Grid.Column>
    );
  }

  render() {
    const {data} = this.props;

    return (
      <Grid columns='equal' className='border-bottom padding-bottom'>
        <Grid.Row>
          {this.renderLabel(5, 'Stock TMC', true)}
          {this.renderNumericValue(3, data.stock)}
          {this.renderLabel(5, 'Lead time de producción', true)}
          {this.renderNumericValue(3, data.leadTime)}
        </Grid.Row>
        <Grid.Row>
          {this.renderLabel(5, 'División Mensual', true)}
          {this.renderNumericValue(3, data.divMonth)}
        </Grid.Row>
      </Grid>
    );
  }
}

export default PartTMC;
